var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/export"
  }, /*#__PURE__*/React.createElement("g", {
    id: "export"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.1841 13.2002H16.9974V20.5069C16.9974 21.0535 16.5441 21.5069 15.9974 21.5069C15.4507 21.5069 14.9974 21.0535 14.9974 20.5069V13.2002H3.81073C3.17073 13.2002 2.66406 13.7069 2.66406 14.3469C2.66406 22.2002 8.14406 27.6802 15.9974 27.6802C23.8507 27.6802 29.3307 22.2002 29.3307 14.3469C29.3307 13.7069 28.8241 13.2002 28.1841 13.2002Z",
    fill: "#116584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.9953 7.73324L19.0753 9.81324C19.462 10.1999 20.102 10.1999 20.4886 9.81324C20.8753 9.42658 20.8753 8.78658 20.4886 8.39991L16.6886 4.61324C16.302 4.22658 15.662 4.22658 15.2753 4.61324L11.4886 8.41324C11.302 8.61324 11.1953 8.86658 11.1953 9.11991C11.1953 9.37324 11.2886 9.62658 11.4886 9.82658C11.8753 10.2132 12.5153 10.2132 12.902 9.82658L14.982 7.74658V13.1999H16.982V7.73324H16.9953Z",
    fill: "#07506D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExport);
export default __webpack_public_path__ + "static/media/ic-export.36e3f6baf8a085b498934dc0a08ee61f.svg";
export { ForwardRef as ReactComponent };